module.exports = {
  endpoints: {
    root: '/api',
    auth: '/api/v2/patient/auth',
    accountAuth: '/api/v2/auth',
  },
  header: 'Authorization',
  login: {
    state: 'login',
  },
  schemes: {
    default: 'Bearer',
    auth: 'Basic',
  },
};



// WEBPACK FOOTER //
// ./main/config/security.js